__turbopack_context__.v({
  "container": "GreetingUser-module-scss-module__ohdzqG__container",
  "row": "GreetingUser-module-scss-module__ohdzqG__row",
});
